import { Injectable, inject } from '@angular/core';

import type {
  VideoEditMenuCallbacks,
  VideoEditMenuData,
  VideoMenuController,
} from '@core/prosemirror-legacy';
import type { DialogRef } from '@core/user-interface-legacy';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { VideoEditDialogComponent } from './video-edit-dialog/video-edit-dialog.component';

@Injectable()
export class VideoMenuService implements VideoMenuController {
  private readonly dialogService = inject(DialogService);

  public editDialogRef: DialogRef | null = null;

  public openEdit(data: VideoEditMenuData, callbacks: VideoEditMenuCallbacks) {
    this.editDialogRef = this.dialogService.openCustom(
      VideoEditDialogComponent,
      { width: DialogWidth.Small },
      { initData: data, callbacks },
    );
    this.editDialogRef.afterClosed.subscribe(() => (this.editDialogRef = null));
    return this.editDialogRef;
  }

  public closeEdit() {
    this.editDialogRef?.close();
  }
}
